import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import heroImage from "@/assets/state-snacks-hero-v4.png";
import { Star } from "lucide-react";



const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-screen pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden flex flex-col bg-[hsl(var(--pastel-mint))]">
      {/* Text content — centered */}
      <div className="relative z-10 mx-auto max-w-5xl px-6 text-center flex-shrink-0">
        {/* Social proof */}
        <div
          className={`mb-6 inline-flex items-center gap-1.5 transition-all duration-700 ${
          loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`
          }
          style={{ transitionDelay: "100ms" }}>

          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) =>
            <Star key={i} className="h-4 w-4 fill-foreground text-foreground" />
            )}
          </div>
          <span className="text-sm font-bold text-foreground ml-1">4.8</span>
          <span className="text-sm text-foreground/60">(500+ early testers)</span>
        </div>

        <h1
          className={`heading-bold text-[3rem] leading-[0.92] text-foreground sm:text-[4.5rem] lg:text-[7rem] transition-all duration-700 ${
          loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`
          }
          style={{ transitionDelay: "200ms" }}>

          Snacks for how you want to feel.
        </h1>
        <p
          className={`mx-auto mt-6 max-w-xl text-base leading-relaxed text-foreground/70 sm:text-lg transition-all duration-700 ${
          loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`
          }
          style={{ transitionDelay: "400ms" }}>

          Say goodbye to mindless munching — functional snacks designed to shift how you feel, not just fill a gap.
        </p>

        <div
          className={`mt-8 flex flex-wrap items-center justify-center gap-4 transition-all duration-700 ${
          loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`
          }
          style={{ transitionDelay: "600ms" }}>

          <Button
            variant="hero"
            size="lg"
            className="py-5 px-10 text-base active:scale-[0.97] hover:scale-[1.02] transition-all duration-200"
            onClick={() => scrollTo("reserve")}>

            Join the Waitlist
          </Button>
        </div>

        {/* Feature badges */}
        <div
          className={`mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 transition-all duration-700 ${
          loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`
          }
          style={{ transitionDelay: "750ms" }}>

          {["Functional", "No Junk", "Science-Backed", "4 States"].map((item) => (
            <span key={item} className="text-xs font-bold uppercase tracking-wider text-foreground/40">
              {item}
            </span>
          ))}
        </div>
      </div>

      {/* Hero product image — with floating pills */}
      <div
        className={`relative mx-auto mt-10 md:mt-14 w-full max-w-5xl px-6 flex-1 flex items-end justify-center transition-all duration-700 ${
        loaded ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"}`
        }
        style={{ transitionDelay: "500ms" }}>

        <img
          src={heroImage}
          alt="State Snacks product pouches — Chill, Sleep, Focus, and Energy"
          className="w-full object-contain relative z-10"
          fetchPriority="high"
          width={1920}
          height={1073} />


      </div>
    </section>);

};

export default HeroSection;